export const ADD_TO_CART_SELECTOR =
    '.result-list__item_product .result-list__item-button input.btn-se';
export const BREADCRUMBS_SELECTOR =
    '.breadcrumbs .breadcrumbs__link[href][data-item-name], .breadcrumbs li[data-item-name]';
export const CATEGORY_FILTER_RADIO_SELECTOR =
    '.filter-list-wrap .filter-list__item .form-choice__input_type_checkbox';
export const LOCATION_FILTER_SELECTOR = '.js-location-filter';
export const LOCATION_FILTER_MOB_SELECTOR = '.js-location-filter-mob';
export const COMPARISON_CHECKED_SELECTOR = '.result-list__item-comparison';
export const SORT_BY_SELECTOR =
    'div.sorting-search-results_dropdown li.filter-list__sublist-item:not(.selected):not(.filter-list__sublist-item_choosen)';
export const FILTER_PILL_SELECTOR = 'li.selected-facets__list-item';
export const FILTER_SHOW_SELECTOR_MOB = '.filter-list-wrap, .filters-wrap-mob';
export const FILTER_SHOW_SELECTOR = '.filter-list__item .filter-list__btn';
export const CATEGORY_FILTER_SELECTOR =
    '.filter-list__item .list__item.filter-list__sublist-item.filter-list__abstract-sublist-item, .category-list li.category-list__item';
export const SHOW_MORE_SELECTOR = '.filter-list__show-more';
export const SUPPORT_LINK_SELECTOR =
    '.support-links .support-links__title-link, .swiper-wrapper  a.swiper-slide-container';
export const RESULT_ITEM_SELECTOR =
    '.result-list__item:not(.result-list__item_document) .result-list__item-title-link';
export const PHONE_LINK_SELECTOR =
    '.result-list__item-availability .result-list__item-availability-link';
export const SHOW_ONLY_LOCAL_SELECTOR = 'div.location-filter-mob';
export const CHAT_SELECTOR = '.analytics-chat';
export const CHAT_ONLINE_SELECTOR = '.analytics-chat-online';
export const APC_BANNER_SELECTOR = '.apc-banner-container .apc-banner';
export const MODEL_FAMILY_SELECTOR = '.filter-list__item .batteries-model-block';
export const DOWNLOAD_BTN_SELECTOR =
    '.result-list__item_product  a[download].btn-se, .result-list__item_product div.js-download-popup, .result-list__item_product a.has-option-download.btn-se';
export const LOCATION_FILTER_INPUT_SELECTOR = '.location-filter input';
export const SELECTED_SORT_OPTION_SELECTOR =
    'div.sorting-search-results_dropdown li.filter-list__sublist-item.selected';
export const RESULT_LIST_ITEM = '.result-list__item';
export const HOW_TO_BUY_SELECTOR = '.result-list__item_product .result-list__item-how-to-buy-link';
export const NO_RESULT_TECHNICAL_SUPPORT_SELECTOR =
    '.no-result-found-items__apology-title .no-results-found-link';
export const COMPARE_NOW_SELECTOR = '.analytics-compare-now';
export const COMPARE_CLOSE_SELECTOR = '.analytics-compare-close';
export const COMPARE_CLEAR_LIST_SELECTOR = '.analytics-clear-list';

export const ADD_TO_CART_LABEL = 'Add-to-cart';
export const DOWNLOAD_LABEL = 'Download';
export const CALL_FOR_AVAILABILITY_LABEL = 'Call-for-availability';
export const HOW_TO_BUY_LABEL = 'How-to-buy';
const VIEW_ALTERNATIVE = 'View-alternative';

const TOP_BANNER_SELECTOR = 'div.results-wrap > .apc-banner-container a';
const MIDDLE_BANNER_SELECTOR = '.result-list .apc-banner-container a';
const LEFT_BANNER_SELECTOR = '.filters-wrap .apc-banner-container_filter-zone a';

const UNKNOWN_MODEL_SELECTOR = '.batteries-model-block-help .batteries-model-block-help-text-js';
const UNKNOWN_MODEL_CLOSE_SELECTOR = '.unknown-model-modal .unknown-model-close-js';
const UNKNOWN_MODEL_CUSTOMER_SELECTOR = '.unknown-model-modal a.unknown-model-link';
const UNKNOWN_MODEL_GOT_IT_SELECTOR =
    '.unknown-model-modal .unknown-model-button-container .unknown-model-button-js';
const FILTER_MODEL_SELECTOR = 'ul.ui-autocomplete li.ui-menu-item';
const CLEAR_ALL_SELECTOR =
    '.js-clear-selected-facets, .filter-list-wrap .filter-list-wrap__clear, .clear-all-filters-link';
const VIEW_ALTERNATIVE_BTN_SELECTOR = '.view-alternative';

const { apcLogService } = window;

export const safeWrap = prop => (...args) => {
    if (!apcLogService) return null;
    return apcLogService[prop](...args);
};
const getClosest = safeWrap('getClosest');
export const getSelectedFilters = dataItemName => {
    try {
        const faset = document.querySelector(
            `.filter-list__item div[data-item-name="${dataItemName}"]`,
        );
        const filterBlock = getClosest(faset, '.filter-list__item');
        return filterBlock.querySelector('li.active[data-item-name]').dataset.itemName;
    } catch (err) {
        return '';
    }
};
export const getCheckedFilters = dataItemName => {
    try {
        const faset = document.querySelector(
            `div.filter-list__item [data-item-name="${dataItemName}"]`,
        );
        const filterBlock = getClosest(faset, '.filter-list__item');
        const selectedInputs = [...filterBlock.querySelectorAll('input[checked=checked]')];
        return selectedInputs
            .map(el => getClosest(el, '[data-item-name]').dataset.itemName)
            .join(',');
    } catch (err) {
        return '';
    }
};
export const getFilterCategoryName = target => {
    const block = getClosest(target, '.filter-list__item, .category-list-wrap');
    const categoryBlock = block.querySelector('.filter-list__btn') || block;
    return categoryBlock ? categoryBlock.dataset.itemName : '';
};
export const getCurrentPage = () => {
    const paginationBlock = document.querySelector('.pagination-apc-outer-wrap');
    const currentPage = paginationBlock ? paginationBlock.dataset.currentPage : null;
    return currentPage ? +currentPage : 0;
};

export const getSelectedFamilyName = () => {
    const modelFamily = document.querySelector(MODEL_FAMILY_SELECTOR);
    return modelFamily ? modelFamily.dataset.selectedFamily : '';
};

export const getLocationFilter = () => {
    const locationFilter = document.querySelector(LOCATION_FILTER_INPUT_SELECTOR);
    return locationFilter && locationFilter.checked ? 'show only' : 'show all';
};
export const getSelectedSortOption = () => {
    const sortOption = document.querySelector(SELECTED_SORT_OPTION_SELECTOR);
    return sortOption ? sortOption.dataset.itemName : '';
};

export const getPositionOfBanner = target => {
    const mapOfPosition = {
        [TOP_BANNER_SELECTOR]: 'Top-Banner',
        [MIDDLE_BANNER_SELECTOR]: 'Middle-Banner',
        [LEFT_BANNER_SELECTOR]: 'Left-Banner',
    };
    const banner = Object.keys(mapOfPosition).find(item => getClosest(target, item));
    return banner ? mapOfPosition[banner] : '';
};

const getProductIdFromUrl = (url = '') => url.match(/.*\/([^?]+)/)[1];

export class Analytics {
    constructor() {
        this.BLOCK = null;
        this.PAGE = '';
        this.matches = safeWrap('matches');
        this.matchThisOrChildren = safeWrap('matchThisOrChildren');
        this.getClosest = getClosest;
        this.observerProducts = null;
    }

    init() {
        this.BLOCK = document.querySelector('body');
        if (this.BLOCK) {
            this.BLOCK.addEventListener('click', e => this.handleEngagementClick(e));
            this.BLOCK.addEventListener('click', e => this.handleEventsClick(e));
            this.BLOCK.addEventListener('click', e => this.handleSalesInsight(e));
            this.BLOCK.addEventListener('change', e => this.handleEventsChange(e));
            this.setObserverProductsChanged();
            this.sendProductsChanged();
        }
    }

    setObserverProductsChanged() {
        const node = document.querySelector('.js-srp-mediator-outer');
        if (!node && this.observerProducts) {
            this.observerProducts.disconnect();
            this.observerProducts = null;
        }
        if (node && !this.observerProducts) {
            const config = { childList: true };
            this.observerProducts = new MutationObserver(this.observerProductChanged);
            this.observerProducts.observe(node, config);
        }
    }

    observerProductChanged = mutationsList => {
        try {
            // eslint-disable-next-line
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length) {
                    this.sendProductsChanged();
                }
            }
        } catch (err) {
            console.error(err);
        }
    };

    getProductIndex(target) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { itemIndex = '' } = block ? block.dataset : {};
        return +itemIndex + 1;
    }

    handleEventsChange(e) {
        const { target } = e;
        if (this.matchThisOrChildren(target, CATEGORY_FILTER_RADIO_SELECTOR)) {
            this.filterChanged(target);
        } else if (
            this.matchThisOrChildren(target, LOCATION_FILTER_SELECTOR) ||
            this.matchThisOrChildren(target, LOCATION_FILTER_MOB_SELECTOR)
        ) {
            this.showOnlyLocal(target);
        } else if (this.matchThisOrChildren(target, COMPARISON_CHECKED_SELECTOR)) {
            this.resultItemCompare(target);
        }
    }

    handleEventsClick(e) {
        const { target } = e;
        if (this.matchThisOrChildren(target, SORT_BY_SELECTOR)) {
            this.sortBy(target);
        } else if (
            this.matchThisOrChildren(target, FILTER_SHOW_SELECTOR_MOB) &&
            this.matchThisOrChildren(target, FILTER_SHOW_SELECTOR)
        ) {
            this.filterShow(target);
        } else if (this.matchThisOrChildren(target, CATEGORY_FILTER_SELECTOR)) {
            this.filterChanged(target);
        } else if (this.matchThisOrChildren(target, SHOW_MORE_SELECTOR)) {
            this.categoryFilterShowMore(target);
        } else if (this.matchThisOrChildren(target, SUPPORT_LINK_SELECTOR)) {
            this.supportLink(target);
        }
        if (this.matchThisOrChildren(target, RESULT_ITEM_SELECTOR)) {
            this.resultItem(target);
        } else if (this.matchThisOrChildren(target, PHONE_LINK_SELECTOR)) {
            this.resultItemCall(target);
        } else if (this.matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            this.resultItemAddCard(target);
        } else if (this.matchThisOrChildren(target, SHOW_ONLY_LOCAL_SELECTOR)) {
            this.showOnlyLocal(target);
        } else if (this.matchThisOrChildren(target, CHAT_SELECTOR)) {
            this.chatOpen(target);
        } else if (this.matchThisOrChildren(target, BREADCRUMBS_SELECTOR)) {
            this.breadCrumbs(target);
        } else if (this.matchThisOrChildren(target, APC_BANNER_SELECTOR)) {
            this.banner(target);
        } else if (this.matchThisOrChildren(target, UNKNOWN_MODEL_SELECTOR)) {
            this.unknownModel(target);
        } else if (this.matchThisOrChildren(target, UNKNOWN_MODEL_CLOSE_SELECTOR)) {
            this.unknownModelClose(target);
        } else if (this.matchThisOrChildren(target, UNKNOWN_MODEL_CUSTOMER_SELECTOR)) {
            this.unknownModelCustomer(target);
        } else if (this.matchThisOrChildren(target, UNKNOWN_MODEL_GOT_IT_SELECTOR)) {
            this.unknownModelGotIt(target);
        } else if (this.matchThisOrChildren(target, FILTER_MODEL_SELECTOR)) {
            this.selectModel(target);
        } else if (this.matchThisOrChildren(target, CLEAR_ALL_SELECTOR)) {
            this.clearAll(target);
        } else if (this.matchThisOrChildren(target, HOW_TO_BUY_SELECTOR)) {
            this.howToBuy(target);
        } else if (this.matchThisOrChildren(target, COMPARE_NOW_SELECTOR)) {
            this.compareNow(target);
        } else if (this.matchThisOrChildren(target, COMPARE_CLOSE_SELECTOR)) {
            this.compareClose(target);
        } else if (this.matchThisOrChildren(target, COMPARE_CLEAR_LIST_SELECTOR)) {
            this.compareClearList(target);
        } else if (this.matchThisOrChildren(target, VIEW_ALTERNATIVE_BTN_SELECTOR)) {
            this.viewAlternative(target);
        }
    }

    handleEngagementClick(e) {
        const { target } = e;
        if (this.matchThisOrChildren(target, CHAT_ONLINE_SELECTOR)) {
            this.chatEngagement(target);
        }
    }

    filterChanged(target) {
        const block = this.getClosest(target, '.filter-list__abstract-sublist-item');
        const input = block.querySelector('input');
        const selected = input
            ? input.checked
            : !this.matches(target, '.filter-list__sublist-item-cross');
        apcLogService(`${this.PAGE}.filterChanged.click`, {
            target,
            category: getFilterCategoryName(target),
            name: block.dataset.itemName,
            selected,
        }); // 7;
    }

    handleSalesInsight(e) {
        const { target } = e;
        if (this.matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            this.addCardSalesInsight(target);
        }
    }

    resultItem(target) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { productId = '' } = block ? block.dataset : {};
        apcLogService(`${this.PAGE}.resultItem.click`, {
            target,
            productId,
        }); // 10;
    }

    resultCTA(target, type) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { productId = '' } = block ? block.dataset : {};
        apcLogService(`${this.PAGE}.resultCTA.click`, {
            productId,
            type,
            target,
        }); // 1 - 3rd;
    }

    resultItemAddCard(target) {
        this.resultCTA(target, ADD_TO_CART_LABEL);
    }

    resultItemCall(target) {
        this.resultCTA(target, CALL_FOR_AVAILABILITY_LABEL);
    }

    howToBuy(target) {
        this.resultCTA(target, HOW_TO_BUY_LABEL);
    }

    viewAlternative(target) {
        const id = getProductIdFromUrl(target.href);
        this.resultCTA(target, `${VIEW_ALTERNATIVE}_${id}`);
    }

    showOnlyLocal(target) {
        const block = this.getClosest(target, '.location-filter, .location-filter-mob');
        const desiredEventTarget = block.querySelector('input');
        apcLogService(`${this.PAGE}.showOnlyLocal.check`, {
            checked: desiredEventTarget
                ? desiredEventTarget.checked
                : !block.classList.contains('location-filter-mob_selected'),
            target,
        }); // 5;
    }

    resultItemCompare(target) {
        const block = this.getClosest(target, RESULT_LIST_ITEM);
        const { checked = false } = target;
        const { productId } = (block && block.dataset) || {};
        apcLogService(`${this.PAGE}.resultItemCompare.check`, {
            target,
            checked,
            productId,
        }); // 12
    }

    sortBy(target) {
        apcLogService(`${this.PAGE}.sortby.select`, {
            name: target.dataset.itemName,
            target,
        }); // 3;
    }

    filterShow(target) {
        const block = this.getClosest(target, '.filter-list__item .filter-list__btn');
        apcLogService(`${this.PAGE}.filterShow.state`, {
            target: block,
            expanded: block.classList.contains('open'),
            name: block.dataset.itemName,
        }); // 6;
    }

    categoryFilterShowMore(target) {
        const parentWithShowMoreClass = this.getClosest(target, '.filter-list__item-content');
        const viewMore = this.matches(parentWithShowMoreClass, '.show-more-items');
        apcLogService(`${this.PAGE}.categoryFilterShowMore.change`, {
            name: getFilterCategoryName(target),
            target,
            viewMore,
        }); // 8;
    }

    supportLink(target) {
        const block = this.getClosest(target, SUPPORT_LINK_SELECTOR);
        apcLogService(`${this.PAGE}.supportLink.click`, {
            target: block,
            name: block.dataset.itemName || '',
        }); // 9;
    }

    chatOpen(target) {
        const available = !!this.getClosest(target, CHAT_ONLINE_SELECTOR);
        apcLogService(`${this.PAGE}.chat.click`, {
            target,
            available,
        }); // chat
    }

    breadCrumbs(target) {
        const block = this.getClosest(target, '.breadcrumbs__link');
        const pageType = (window.tc_vars && window.tc_vars.page_name) || '';
        apcLogService(`${this.PAGE}.breadCrumbs.click`, {
            target,
            itemName: block ? block.dataset.itemName : '',
            pageType,
        }); // breadCrumbs
    }

    banner(target) {
        const block = this.getClosest(target, '.apc-banner');
        apcLogService(`${this.PAGE}.banner.click`, {
            target: block,
            name: block.dataset.itemName || '',
            url: block ? block.href : '',
        }); // banner
    }

    addCardSalesInsight(target) {
        const block = this.getClosest(target, '.result-list .result-list__item_product');
        apcLogService(`${this.PAGE}.addCardSalesInsight.click`, {
            target,
            productDetails: {
                ...this.getProductVariables(block),
                product_qty: '1',
            },
            cartId: (window.tc_vars && window.tc_vars.cart_id) || '',
        }); // addCard SalesInsight
    }

    sendProductsChanged() {
        apcLogService(`${this.PAGE}.productsChangedSalesInsight.click`, {
            target: document,
            productDetails: this.getListProducts(),
        }); // productsChanged SalesInsight
    }

    selectModel(target) {
        const block = this.getClosest(target, 'li.ui-menu-item');
        apcLogService(`${this.PAGE}.modelFilter.click`, {
            target,
            productId: `P-${block.dataset.partNumber || ''}`,
        });
    }

    unknownModel(target) {
        apcLogService(`${this.PAGE}.unknownModel.click`, {
            target,
        }); // 670 unknownModel
    }

    unknownModelClose(target) {
        apcLogService(`${this.PAGE}.unknownModelClose.click`, {
            target,
        }); // 677 unknownModelClose
    }

    unknownModelCustomer(target) {
        apcLogService(`${this.PAGE}.unknownModelCustomer.click`, {
            target,
        }); // 678 hardwareModelCustomer
    }

    unknownModelGotIt(target) {
        apcLogService(`${this.PAGE}.unknownModelGotIt.click`, {
            target,
        }); // 679 hardwareModelGotIt
    }

    clearAll(target) {
        const isResult = target.classList.contains('clear-all-filters-link');
        apcLogService(`${this.PAGE}.clearAll.click`, {
            target,
            isResult,
        }); // clear all
    }

    supportNoResults(target) {
        apcLogService(`${this.PAGE}.supportNoResults.click`, {
            target,
        });
    }

    compareNow(target) {
        const countElem = document.querySelector('#comparison-widget .analytics-compare-count');
        const count = countElem ? countElem.textContent : '';
        apcLogService(`${this.PAGE}.compareNow.click`, {
            target,
            count,
        });
    }

    compareClose(target) {
        apcLogService(`${this.PAGE}.compareClose.click`, {
            target,
        });
    }

    compareClearList(target) {
        apcLogService(`${this.PAGE}.compareClearList.click`, {
            target,
        });
    }

    chatEngagement(target) {
        apcLogService(`${this.PAGE}.chatEngagement.click`, {
            target,
            url: window.location.href,
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getProductVariables(element) {
        try {
            const currencyMeta = document.querySelector('meta[name="tagging-currency"]');
            const productVariant = element.querySelector('.badge-container');
            const productPrice = element.querySelector('[data-price]');
            const category6 = element.querySelector('[data-product-category-6]');
            const isPriceNew = element.querySelector('.result-list__item-price_new');
            const stockEl = element.querySelector('[data-stock]');
            const stock = stockEl ? stockEl.dataset.stock : '0';
            const priceSpider = element.dataset['productCategory-5'] === 'true';
            return {
                product_id: element.dataset.productId || '',
                product_variant: productVariant ? productVariant.dataset.productVariant : '',
                product_name: element.dataset.itemName || '',
                product_brand: element.dataset.itemBrand || '',
                product_discount: isPriceNew || productPrice ? +Boolean(isPriceNew) : '',
                product_currency: currencyMeta ? currencyMeta.content : '',
                product_price_tax_included: productPrice ? productPrice.dataset.price : '',
                product_price_tax_free: productPrice ? productPrice.dataset.taxFreePrice : '',
                product_stock: stock,
                product_category_1: element.dataset['productCategory-1'] || '',
                product_category_2: element.dataset['productCategory-2'] || '',
                product_category_3: element.dataset['productCategory-3'] || '',
                product_category_4: `Direct-ecomm_${productPrice ? 'yes' : 'no'}`,
                product_category_5: `Indirect-ecomm_${priceSpider ? 'yes' : 'no'}`,
                product_category_6: category6 ? category6.dataset['productCategory-6'] || '' : '',
            };
        } catch (err) {
            return {};
        }
    }

    getListProducts() {
        try {
            const products = [
                ...document.querySelectorAll('.result-list .result-list__item_product'),
            ];
            return products.map(el => this.getProductVariables(el));
        } catch {
            return [];
        }
    }
}
